/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Today_Stat_SetsInputs */

const en_us2_today_stat_sets = /** @type {(inputs: Today_Stat_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`set`);
	return /** @type {LocalizedString} */ (`sets`)
	
};

const pt_br2_today_stat_sets = /** @type {(inputs: Today_Stat_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`série`);
	return /** @type {LocalizedString} */ (`séries`)
	
};

const es_419_today_stat_sets = /** @type {(inputs: Today_Stat_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`serie`);
	return /** @type {LocalizedString} */ (`series`)
	
};

const pt_pt2_today_stat_sets = /** @type {(inputs: Today_Stat_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`série`);
	return /** @type {LocalizedString} */ (`séries`)
	
};

const fr_fr2_today_stat_sets = /** @type {(inputs: Today_Stat_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`série`);
	return /** @type {LocalizedString} */ (`séries`)
	
};

const de_de2_today_stat_sets = /** @type {(inputs: Today_Stat_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Satz`);
	return /** @type {LocalizedString} */ (`Sätze`)
	
};

const it_it2_today_stat_sets = /** @type {(inputs: Today_Stat_SetsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`serie`);
	return /** @type {LocalizedString} */ (`serie`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "set" |
* | * | "sets" |
*
* @param {Today_Stat_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_stat_sets = /** @type {((inputs: Today_Stat_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Stat_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_stat_sets(inputs)
	if (locale === "es-419") return es_419_today_stat_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_today_stat_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_today_stat_sets(inputs)
	if (locale === "de-DE") return de_de2_today_stat_sets(inputs)
	if (locale === "it-IT") return it_it2_today_stat_sets(inputs)
	return en_us2_today_stat_sets(inputs)
});
export { today_stat_sets as "today.stat_sets" }